module.exports = __webpack_public_path__ + "static/red-line-256ff740bc69aad3d69efb04eab1c68d.svg";